import { useCallback } from 'react'
import { useEnterpriseAccountRequestVerificationEmailMutation } from 'domains/public/api'

interface RequestVerificationEmail {
  email: string
  reCaptchaToken: string
}

export const useEnterpriseAccountRequestVerificationEmail = () => {
  const [triggerMutation, { data, loading, error }] =
    useEnterpriseAccountRequestVerificationEmailMutation()

  const requestVerificationEmail = useCallback(
    (args: RequestVerificationEmail) =>
      triggerMutation({
        variables: {
          ...args,
        },
      }),
    [triggerMutation]
  )

  const success = Boolean(data?.enterpriseAccountRequestEmailVerification?.success)

  return {
    requestVerificationEmail,
    apiSuccess: success,
    apiLoading: loading,
    apiError: error,
  }
}
